import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import {formatDate} from '../../utils/helper.js';
import Paginator from "../../components/Paginator"; 
import {statusColor} from "../../assets/utils/statusColors";
import { selectStoredPermissions } from '../../stores/permissionsSlice';
import LoyaltyModal from '../../components/LoyaltyModal';

const UserDetails = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [currency] = useState(process.env.REACT_APP_CURRENCY);
  const [tab, setTab] = useState("info");
  const [type, setType] = useState("");
  const [user, setUser] = useState([]);
  const [orders, setOrders] = useState([]);
  const [points, setPoints] = useState([]);
  const [pagination, setPagination] = useState({});
  const [apiData, setApiData] = useState({
        search: "",
        page: 1,
        branch_id: id,
  });
    const [isModalOpen, setIsModalOpen] = useState(false);
  
  const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    getLoyaltyHistory();
  };

    const handleOpenModal = (type) => {
    setIsModalOpen(true);
    setType(type);
  };



  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);

  const getSingleData = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `users/${id}`,
        data: {get_for:'details'}
      });
      const data = response.data;
      if (data.status) {
        const user = data.data;
        setUser(user);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (tab === "orders") {
      getOrders();
    }
    if (tab === "loyalty") {
      getLoyaltyHistory();
    }
  }, [tab]);


  const getOrders = async () => {
      try {
          setIsLoader(true);
          const response = await ApiService.request({
              method: "GET",
              url: "orders", // Replace with your API endpoint
              data: {user_id:id, page:apiData.page}
          });
          const data = response.data;
          if (data.status) {
              setOrders(data.data);
              setPagination(data.pagination);
          } else {
              toast.error(data.message);
          }
          setIsLoader(false);
      } catch (error) {
          setIsLoader(false);
      }
      
  };

  const getLoyaltyHistory = async () => {
      try {
          setIsLoader(true);
          const response = await ApiService.request({
              method: "GET",
              url: "/users-loyalty", // Replace with your API endpoint
              data: {user_id:id, page:apiData.page}
          });
          const data = response.data;
          if (data.status) {
              setPoints(data.data);
              setPagination(data.pagination);
          } else {
              toast.error(data.message);
          }
          setIsLoader(false);
      } catch (error) {
          setIsLoader(false);
      }
      
  };



 
  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div
          id="kt_app_toolbar_container"
          className="app-container container-xxl d-flex flex-stack"
        >
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              User: {user?.name}
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-user text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">
                  Dashboard
                </Link>
              </li>
              <li className="breadcrumb-user">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-user text-muted">
                <Link to="/users" className="text-muted text-hover-primary">
                  Users
                </Link>
              </li>
            </ul>
          </div>
          <div className="d-flex align-users-center gap-2 gap-lg-3">
                <button type="button" className="btn btn-sm btn-secondary me-3" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left-short fs-1"></i>  Back
                </button>
                  <button type='button' onClick={()=>handleOpenModal('reward')} className='btn btn-success btn-sm '>Reward Loyalty</button>
                  <button type='button' onClick={()=>handleOpenModal('redeem')} className='btn btn-danger btn-sm '>Redeem Loyalty</button>
          </div>

            
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-5">

                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-user" role="presentation">
                    <button  className={`nav-link fs-6 px-5 ${tab === "info" ? "active" : ""}`}
                            onClick={() => setTab("info")}
                     type="button"> <i className="bi bi-building-fill fs-5"></i> User Info</button>
                  </li>
                  <li class="nav-user" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "orders" ? "active" : ""}`}
                            onClick={() => setTab("orders")}
                      type="button" ><i className="bi bi-clipboard-data-fill fs-5"></i> Orders</button>
                  </li>
                  <li class="nav-user" role="presentation">
                    <button className={`nav-link fs-6 px-5 ${tab === "loyalty" ? "active" : ""}`}
                            onClick={() => setTab("loyalty")}
                      type="button" ><i className="bi bi-coin fs-5"></i> Loyalty History</button>
                  </li>
              

                 
                </ul>

                {!isLoader && 
                  <div class="tab-content" id="myTabContent">
                    {tab === "info" && (
                      <div class="tab-pane fade show active" >
                        <div className="table-responsive mt-5 w-lg-75">
                          <table className="table align-middle table-striped buser fs-6">
                            <tbody>
                              <tr>
                                <th className="px-3 fw-semibold">Picture</th>
                                <th>
                                  {user.picture && 
                                      <img src={user.picture} alt="picture" className="w-70px h-70px object-cover rounded" />
                                  }
                                </th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">User Name</th>
                                <th>{user?.name}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Email</th>
                                <th>{user?.email}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold">Phone</th>
                                <th>{user?.phone}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Loyalty Code</th>
                                <th>{user?.loyalty_code}</th>
                              </tr>
                              <tr>
                                <th className="px-3 fw-semibold"> Loyalty Points</th>
                                <th>{user?.loyalty_points}</th>
                              </tr>
                             
                            
                              <tr>
                                <th className="px-3 fw-semibold"> Registered at</th>
                                <td>{formatDate(user?.createdAt,'DD MMM, hh:mm A')} </td>
                              </tr>
                            
                            
                            </tbody>
                          
                          </table>
                        </div>
                      </div>
                    )}
                   
                    {tab === "orders" && (
                      <div class="tab-pane fade show active">
                            <div className="table-responsive">
                                <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th>Order #</th>
                                              <th>Branch</th>
                                              <th>Pay Method</th>
                                              <th>Order Total</th>
                                              <th>Order Type</th>
                                              <th>Order From</th>
                                              <th>Status</th>
                                              <th>Order Date</th>
                                              <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600 fs-6">
                                        {orders.length > 0 ? orders.map((item, index) => (
                                              <tr key={index}>
                                                  <td>
                                                      <Link to={`/orders/${item._id}`} className='text-gray-800 '>
                                                      #{item.order_code}
                                                      </Link>
                                                  </td>

                                                  <td>  {item.branch?.name}</td>
                                                  <td> {item.payment_method}</td>
                                                  <td> {currency} {item.grand_total.toFixed(2)}</td>
                                                  <td> {item.type}</td>
                                                  <td> {item.order_from}</td>
                                                  <td>
                                                      <button className="p-0 btn btn-transparent">
                                                          <span className={`badge bg-${statusColor[item.status]}`}  >
                                                              {item.status }
                                                          </span>
                                                      </button>
                                                  </td>
                                                  <td>  {formatDate(item.createdAt,'DD MMM YYYY, hh:mm A')} </td>
                                                  <td className="mt-2">
                                                      { selectStoredPermissions().includes('detail-orders') &&
                                                      <Link to={`/orders/${item._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                          <i className="bi bi-eye-fill fs-6"></i>
                                                      </Link>
                                                      }
                                                      
                                                  </td>
                                              </tr>
                                          )) : (
                                              <tr>
                                                  <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                              </tr>
                                          )}
                                    </tbody>
                                </table> 
                                {isLoader && (
                                    <Loader text="Loading" size="30" className="text-center"  />
                                )}
                                <span>Total Records: {pagination?.total_records}</span>


                                {pagination.total_pages > 1 && (
                                    <Paginator
                                        page={pagination.current_page}
                                        rows={pagination.per_page}
                                        totalRecords={pagination.total_records}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                      </div>
                    )}

                    {tab === "loyalty" && (
                      <div class="tab-pane fade show active">
                            <div className="table-responsive">
                                <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                              <th>Title</th>
                                              <th>Order</th>
                                              <th>Points</th>
                                              <th> Date</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600 fs-6">
                                        {points.length > 0 ? points.map((item, index) => (
                                              <tr key={index}>
                                                <td>  {item.title}</td>

                                                <td>
                                                    {item.order_id ?(
                                                      <Link to={`/orders/${item.order_id}`} className='text-gray-800 '>
                                                        #{item.order_id?.order_code || 'N/A'}
                                                      </Link>
                                                    ):(
                                                      <span className='text-gray-800 '>N/A</span>
                                                    )}
                                                      
                                                  </td>
                                                
                                                  <td>  
                                                      <span className= {`badge text-gray-100 ${item.points_type == 'reward' ? 'bg-success':'bg-danger'}`}> 
                                                        { item.points_type == 'reward'? '+':'-'}
                                                        { item.loyalty_points}
                                                      </span>
                                                  </td>
                                                 
                                                  <td>  {formatDate(item.createdAt,'DD MMM YYYY, hh:mm A')} </td>
                                                  
                                              </tr>
                                          )) : (
                                              <tr>
                                                  <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                              </tr>
                                          )}
                                    </tbody>
                                </table> 
                                {isLoader && (
                                    <Loader text="Loading" size="30" className="text-center"  />
                                )}
                                <span>Total Records: {pagination?.total_records}</span>


                                {pagination.total_pages > 1 && (
                                    <Paginator
                                        page={pagination.current_page}
                                        rows={pagination.per_page}
                                        totalRecords={pagination.total_records}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                      </div>
                    )}


                  </div>
                }
                {isLoader && 
                  <Loader color="black" className="mt-5" text="Loading" size="30" />
                }
                
                {isModalOpen && <LoyaltyModal userId={id} type={type}  closeModal={handleCloseModal} />}
                
             
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
